// Easy Responsive Tabs Plugin (vanilla JS port — single-consumer, snippets/rfr-product-tab.liquid)
function easyResponsiveTabs(rootEl, options) {
  if (!rootEl) return;

  var defaults = {
    type: 'default', //default, vertical, accordion;
    width: 'auto',
    fit: true,
    closed: false,
    activate: function () {}
  };
  var opt = Object.assign({}, defaults, options);
  var vtabs = 'vertical', accord = 'accordion';

  var respTabsList = rootEl.querySelector('ul.resp-tabs-list');
  rootEl.querySelectorAll('ul.resp-tabs-list li').forEach(function (li) {
    li.classList.add('resp-tab-item');
  });
  rootEl.style.display = 'block';
  rootEl.style.width = opt.width;

  rootEl.querySelectorAll('.resp-tabs-container > div').forEach(function (div) {
    div.classList.add('resp-tab-content');
  });

  if (opt.type === vtabs) {
    rootEl.classList.add('resp-vtabs');
  }
  if (opt.fit === true) {
    rootEl.style.width = '100%';
    rootEl.style.margin = '0px';
  }
  if (opt.type === accord) {
    rootEl.classList.add('resp-easy-accordion');
    if (respTabsList) respTabsList.style.display = 'none';
  }

  // Assigning the h2 markup to accordion title
  var tabContents = Array.from(rootEl.querySelectorAll('.resp-tab-content'));
  tabContents.forEach(function (content) {
    var h2 = document.createElement('h2');
    h2.className = 'resp-accordion';
    h2.setAttribute('role', 'tab');
    var arrow = document.createElement('span');
    arrow.className = 'resp-arrow';
    h2.appendChild(arrow);
    content.parentNode.insertBefore(h2, content);
  });

  var tabItems = Array.from(rootEl.querySelectorAll('.resp-tab-item'));
  var accordionHeaders = Array.from(rootEl.querySelectorAll('.resp-accordion'));

  accordionHeaders.forEach(function (h2, index) {
    var tabItem = tabItems[index];
    if (tabItem) {
      h2.innerHTML += tabItem.innerHTML;
    }
    h2.setAttribute('aria-controls', 'tab_item-' + index);

    var areaTabValue = tabItem ? tabItem.getAttribute('area-tab') : null;
    h2.setAttribute('area-tab', areaTabValue === 'review_tab' ? 'review_tab' : 'others');
  });

  // Assigning the 'aria-controls' to Tab items
  tabItems.forEach(function (tabItem, index) {
    tabItem.setAttribute('aria-controls', 'tab_item-' + index);
    tabItem.setAttribute('role', 'tab');
  });

  // First active tab, keep closed if option = 'closed' or option is 'accordion' and the element is in accordion mode
  var tabsListVisible = !!respTabsList && respTabsList.offsetParent !== null;
  var shouldOpenFirst = opt.closed !== true &&
    !(opt.closed === 'accordion' && !tabsListVisible) &&
    !(opt.closed === 'tabs' && tabsListVisible);

  if (shouldOpenFirst) {
    if (tabItems[0]) tabItems[0].classList.add('resp-tab-active');
    if (accordionHeaders[0]) accordionHeaders[0].classList.add('resp-tab-active');
    if (tabContents[0]) {
      tabContents[0].classList.add('resp-tab-content-active');
      tabContents[0].style.display = 'block';
    }
  }

  // Assigning the 'aria-labelledby' attr to tab-content
  tabContents.forEach(function (content, index) {
    content.setAttribute('aria-labelledby', 'tab_item-' + index);
  });

  // Tab Click action function
  rootEl.querySelectorAll('[role="tab"]').forEach(function (currentTab) {
    currentTab.addEventListener('click', function () {
      var tabAria = currentTab.getAttribute('aria-controls');
      var isAccordion = currentTab.classList.contains('resp-accordion');
      var isActive = currentTab.classList.contains('resp-tab-active');
      var activeContent = rootEl.querySelector('.resp-tab-content-active');

      if (isAccordion && isActive) {
        if (activeContent) {
          activeContent.style.display = 'none';
          activeContent.classList.add('resp-accordion-closed');
        }
        currentTab.classList.remove('resp-tab-active');
        return;
      }

      if (!isActive && isAccordion) {
        rootEl.querySelectorAll('.resp-tab-active').forEach(function (el) { el.classList.remove('resp-tab-active'); });
        if (activeContent) {
          activeContent.style.display = 'none';
          activeContent.classList.remove('resp-tab-content-active', 'resp-accordion-closed');
        }
        rootEl.querySelectorAll('[aria-controls="' + tabAria + '"]').forEach(function (el) { el.classList.add('resp-tab-active'); });

        var target = rootEl.querySelector('.resp-tab-content[aria-labelledby="' + tabAria + '"]');
        if (target) {
          target.style.display = 'block';
          target.classList.add('resp-tab-content-active');
        }
      } else {
        rootEl.querySelectorAll('.resp-tab-active').forEach(function (el) { el.classList.remove('resp-tab-active'); });
        if (activeContent) {
          activeContent.removeAttribute('style');
          activeContent.classList.remove('resp-tab-content-active', 'resp-accordion-closed');
        }
        rootEl.querySelectorAll('[aria-controls="' + tabAria + '"]').forEach(function (el) { el.classList.add('resp-tab-active'); });

        var target = rootEl.querySelector('.resp-tab-content[aria-labelledby="' + tabAria + '"]');
        if (target) {
          target.classList.add('resp-tab-content-active');
          target.style.display = 'block';
        }
      }

      if (typeof opt.activate === 'function') {
        opt.activate.call(currentTab);
      }
    });
  });

  // Window resize function
  window.addEventListener('resize', function () {
    rootEl.querySelectorAll('.resp-accordion-closed').forEach(function (el) {
      el.removeAttribute('style');
    });
  });
}

let prevBadgeClick = document.querySelector('.jdgm-prev-badge');
if(prevBadgeClick) {
  document.querySelector('.jdgm-prev-badge').addEventListener('click', function() {
    // for desktop

    document.querySelectorAll('.resp-tabs-list .resp-tab-item').forEach(item => {
      item.classList.remove('resp-tab-active');
    });
    document.querySelector('.resp-tabs-list .resp-tab-item[area-tab="review_tab"]').classList.add('resp-tab-active');


    // for mobile

    document.querySelectorAll('.resp-tabs-container .resp-accordion').forEach(item => {
      item.classList.remove('resp-tab-active');
    });
    document.querySelector('.resp-tabs-container .resp-accordion[area-tab="review_tab"]').classList.add('resp-tab-active');


    //for both

    document.querySelectorAll('.resp-tabs-container .resp-tab-content').forEach(content => {
      content.classList.remove('resp-tab-content-active');
      content.style.display = 'none';
    });

    let activeContent = document.querySelector('.resp-tabs-container .resp-tab-content[area-content="review_content"]');
    activeContent.classList.add('resp-tab-content-active');
    activeContent.style.display = 'block';
  });
}
